import React from 'react';

import { Box } from '@alpha/ui-lib/ui/external';
import { IAutocompleteSelectOption } from '@alpha/ui-lib/ui/Select';
import { APTooltip } from '@alpha/ui-lib/ui/Tooltip';

import { useStyles } from './RenderValue.styles';

interface IProps {
  selectedPaymentPurpose: IAutocompleteSelectOption,
}
const RenderValue: React.FC<IProps> = ({ selectedPaymentPurpose }: IProps) => {
  const styles = useStyles();
  const { label } = selectedPaymentPurpose;

  return (
    <Box className={styles.root} key={label}>
      <APTooltip
        title={<Box whiteSpace="normal">{label}</Box>}
        PopperProps={{
          style: {
            wordWrap: 'normal',
            maxWidth: '400px',
            whiteSpace: 'normal',
          },
        }}
        leaveDelay={0}
        leaveTouchDelay={0}
        TransitionProps={{
          exit: false,
        }}
      >
        <div className={styles.description}>
          {label}
        </div>
      </APTooltip>
    </Box>
  );
};

export default RenderValue;
